<template>
  <div :id="$style.customer_voice_list">
    <div :class="$style.selector">
      <!-- <b-pagination
        v-model="currentPage"
        :class="$style.pagenate"
        :total-rows="count"
        :per-page="perPage"
        @input="handleClick(selected, currentPage)"
        :limit="'2'"
      ></b-pagination>-->
      <multiselect
        v-model="selected_y"
        :class="$style.select"
        :options="year"
        :selectLabel="''"
        :deselectLabel="''"
        :searchable="false"
        @input="handleClick(selected_y, 1)"
      ></multiselect>
      <multiselect
        v-model="selected_m"
        :class="$style.select"
        :options="month"
        :selectLabel="''"
        :deselectLabel="''"
        :searchable="false"
        :max-height="800"
        @input="handleClick(selected_y, selected_m)"
      ></multiselect>
    </div>

    <div :class="$style.list">
      <customer-voice-detail v-for="item in items_data" :key="item.id" :item="item"></customer-voice-detail>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import CustomerVoiceDetail from "@/components/molecules/CustomerVoiceDetail.vue";
import Multiselect from "vue-multiselect";
// import moment from "moment";

import { CustomerVoice } from "@/api";

export default Vue.extend({
  name: "CustomerVoiceList",

  components: {
    CustomerVoiceDetail,
    Multiselect
  },
  mounted() {
    const now = new Date();
    // const month = now.getMonth()+1; // 最新月表示する場合
    this.createYearlist(now.getFullYear());
    const year = '最近の10件'
    const month = ''; // 初期表示を1月にする
    this.handleClick(year,month);
    this.year = this.year.reverse();
    this.selected_y = year;
    this.selected_m = month;
  },
  data() {
    return {
      items_data: [],
      selected_y: "",
      selected_m: "",
      year: [],
      month: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      //currentPage: 1,
      perPage: 1,
      count: 0
    };
  },
  methods: {
    createYearlist(year) {
      // selectorのためのlistを作成
      const jsranger = require("jsranger");
      this.year = jsranger(2006, year + 1, 1);
      this.year.push('最近の10件')

    },
    handleClick(year, month) {
      if (year=='最近の10件'){
        CustomerVoice.getLatestCustomerItem(10).then(({ results }) => {
          this.items_data = results;
        });
      }else{
        CustomerVoice.getCustomerItem(year, month).then(({ count, results }) => {
          this.count = Math.ceil(count / 2);
          this.items_data = results;
          // this.selected_m = month;
        });
      }
    },
    
    
    // handleClickを使用したかったが正常に動作しなかったため用意した
    // selectYear(year: string) {
    //   CustomerVoice.getCustomerItem(year, 1).then(({ count, results }) => {
    //     this.count = Math.ceil(count / 2);
    //     this.items_data = results;
    //     this.currentPage = 1;
    //   });
    // }
  }
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  #customer_voice_list {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex-wrap: wrap;
    .selector {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 300px;
      margin: 10px 0px;
      margin-top: 20px;
      .pagenate {
        margin: 0;
        // width: 90px;
      }
      .select {
        width: 100px;
        margin-left: 10px;
      }
    }
    .list {
      display: flex;
      justify-content: center;
      align-self: center;
      flex-direction: column;
      flex-wrap: wrap;
    }
  }
}
@media only screen and (min-width: 1024px) {
  #customer_voice_list {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex-wrap: wrap;
    .selector {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 850px;
      margin: 20px 0px;
      margin-top: 40px;
      .pagenate {
        margin: 0;
      }
      .select {
        width: 200px;
        margin: 0 20px;
      }
    }
    .list {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
    }
  }
}
</style>
